import React from "react";
import { DragSource, DropTarget } from "react-dnd";
import "./mapComponent.less";

import "../list.less";

let dragingIndex = -1;
class BodyRow extends React.Component {
   render() {
      const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = this.props;
      const style = { ...restProps.style, cursor: "move" };

      let { className } = restProps;
      if (isOver) {
         if (restProps.index > dragingIndex) {
            className += " drop-over-downward";
         }
         if (restProps.index < dragingIndex) {
            className += " drop-over-upward";
         }
      }

      return connectDragSource(
         connectDropTarget(<tr {...restProps} className={className} style={style} />)
      );
   }
}
const rowSource = {
   beginDrag(props) {
      dragingIndex = props.index;
      return {
         index: props.index
      };
   }
};
const rowTarget = {
   drop(props, monitor) {
      const dragIndex = monitor.getItem().index;
      const hoverIndex = props.index;
      if (dragIndex === hoverIndex) {
         return;
      }
      props.moveRow(dragIndex, hoverIndex);
      monitor.getItem().index = hoverIndex;
   }
};
export const DragableBodyRow = DropTarget("row", rowTarget, (connect, monitor) => ({
   connectDropTarget: connect.dropTarget(),
   isOver: monitor.isOver()
}))(
   DragSource("row", rowSource, (connect) => ({
      connectDragSource: connect.dragSource()
   }))(BodyRow)
);
